// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"9de6022f","78":"7137503c","227":"fd6cdbab","463":"6962e450","488":"29b71886","735":"5353191f","954":"81d45c80"}[chunkId] + ".chunk.js";
};